import { Directive, Inject, OnChanges, TemplateRef, ViewContainerRef } from '@angular/core';
import { COMMONS_ENV } from '@damofire/data-angular-commons';
import { AutoUnsubscribe } from '../auto-unsubscribe.decorator';

@AutoUnsubscribe()
@Directive({
  selector: '[appShowOnRepairMode]',
  standalone: true,
})
export class ShowOnRepairModeRepairDirective implements OnChanges {
  constructor(
    private readonly templateRef: TemplateRef<any>,
    private readonly viewContainer: ViewContainerRef,
    @Inject(COMMONS_ENV) private readonly environment: any,
  ) {
    this.showOrHide();
  }

  ngOnChanges(): void {
    this.showOrHide();
  }

  private showOrHide(): void {
    this.viewContainer.clear();

    if (this.environment.repairMode) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }
}
